import { render, staticRenderFns } from "./FrecuenciaEditModal.vue?vue&type=template&id=380d169e"
import script from "./FrecuenciaEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FrecuenciaEditModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports